// source: address.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.com.pb.address.ADDRESS_TYPE', null, global);
goog.exportSymbol('proto.com.pb.address.AddressInfo', null, global);
goog.exportSymbol('proto.com.pb.address.AddressList', null, global);
goog.exportSymbol('proto.com.pb.address.AddressTransportationInfo', null, global);
goog.exportSymbol('proto.com.pb.address.AddressTransportationInfoRequest', null, global);
goog.exportSymbol('proto.com.pb.address.TRANSPORTATION_MODE', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.pb.address.AddressList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.pb.address.AddressList.repeatedFields_, null);
};
goog.inherits(proto.com.pb.address.AddressList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.pb.address.AddressList.displayName = 'proto.com.pb.address.AddressList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.pb.address.AddressInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.pb.address.AddressInfo.repeatedFields_, null);
};
goog.inherits(proto.com.pb.address.AddressInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.pb.address.AddressInfo.displayName = 'proto.com.pb.address.AddressInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.pb.address.AddressTransportationInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.pb.address.AddressTransportationInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.pb.address.AddressTransportationInfoRequest.displayName = 'proto.com.pb.address.AddressTransportationInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.pb.address.AddressTransportationInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.pb.address.AddressTransportationInfo.repeatedFields_, null);
};
goog.inherits(proto.com.pb.address.AddressTransportationInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.pb.address.AddressTransportationInfo.displayName = 'proto.com.pb.address.AddressTransportationInfo';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.pb.address.AddressList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.pb.address.AddressList.prototype.toObject = function(opt_includeInstance) {
  return proto.com.pb.address.AddressList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.pb.address.AddressList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.pb.address.AddressList.toObject = function(includeInstance, msg) {
  var f, obj = {
    addressInfoList: jspb.Message.toObjectList(msg.getAddressInfoList(),
    proto.com.pb.address.AddressInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.pb.address.AddressList}
 */
proto.com.pb.address.AddressList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.pb.address.AddressList;
  return proto.com.pb.address.AddressList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.pb.address.AddressList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.pb.address.AddressList}
 */
proto.com.pb.address.AddressList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.pb.address.AddressInfo;
      reader.readMessage(value,proto.com.pb.address.AddressInfo.deserializeBinaryFromReader);
      msg.addAddressInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.pb.address.AddressList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.pb.address.AddressList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.pb.address.AddressList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.pb.address.AddressList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddressInfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.pb.address.AddressInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AddressInfo address_info = 1;
 * @return {!Array<!proto.com.pb.address.AddressInfo>}
 */
proto.com.pb.address.AddressList.prototype.getAddressInfoList = function() {
  return /** @type{!Array<!proto.com.pb.address.AddressInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.pb.address.AddressInfo, 1));
};


/**
 * @param {!Array<!proto.com.pb.address.AddressInfo>} value
 * @return {!proto.com.pb.address.AddressList} returns this
*/
proto.com.pb.address.AddressList.prototype.setAddressInfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.pb.address.AddressInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.pb.address.AddressInfo}
 */
proto.com.pb.address.AddressList.prototype.addAddressInfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.pb.address.AddressInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.pb.address.AddressList} returns this
 */
proto.com.pb.address.AddressList.prototype.clearAddressInfoList = function() {
  return this.setAddressInfoList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.pb.address.AddressInfo.repeatedFields_ = [10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.pb.address.AddressInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.com.pb.address.AddressInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.pb.address.AddressInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.pb.address.AddressInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    addressCity: jspb.Message.getFieldWithDefault(msg, 2, ""),
    addressDetail: jspb.Message.getFieldWithDefault(msg, 3, ""),
    addressChoose: jspb.Message.getFieldWithDefault(msg, 4, ""),
    addressLongigute: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    addressLatitute: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    addressProvinceCode: jspb.Message.getFieldWithDefault(msg, 7, 0),
    addressCityCode: jspb.Message.getFieldWithDefault(msg, 8, 0),
    transportationMode: jspb.Message.getFieldWithDefault(msg, 9, 0),
    transportationDescriptionList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
    name: jspb.Message.getFieldWithDefault(msg, 11, ""),
    mobile: jspb.Message.getFieldWithDefault(msg, 12, ""),
    shopId: jspb.Message.getFieldWithDefault(msg, 13, 0),
    addressType: jspb.Message.getFieldWithDefault(msg, 14, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.pb.address.AddressInfo}
 */
proto.com.pb.address.AddressInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.pb.address.AddressInfo;
  return proto.com.pb.address.AddressInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.pb.address.AddressInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.pb.address.AddressInfo}
 */
proto.com.pb.address.AddressInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressCity(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressDetail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressChoose(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setAddressLongigute(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setAddressLatitute(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAddressProvinceCode(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAddressCityCode(value);
      break;
    case 9:
      var value = /** @type {!proto.com.pb.address.TRANSPORTATION_MODE} */ (reader.readEnum());
      msg.setTransportationMode(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addTransportationDescription(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setShopId(value);
      break;
    case 14:
      var value = /** @type {!proto.com.pb.address.ADDRESS_TYPE} */ (reader.readEnum());
      msg.setAddressType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.pb.address.AddressInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.pb.address.AddressInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.pb.address.AddressInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.pb.address.AddressInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAddressCity();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddressDetail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAddressChoose();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAddressLongigute();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getAddressLatitute();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = message.getAddressProvinceCode();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getAddressCityCode();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getTransportationMode();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getTransportationDescriptionList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getShopId();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getAddressType();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.com.pb.address.AddressInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.pb.address.AddressInfo} returns this
 */
proto.com.pb.address.AddressInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string address_city = 2;
 * @return {string}
 */
proto.com.pb.address.AddressInfo.prototype.getAddressCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.pb.address.AddressInfo} returns this
 */
proto.com.pb.address.AddressInfo.prototype.setAddressCity = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string address_detail = 3;
 * @return {string}
 */
proto.com.pb.address.AddressInfo.prototype.getAddressDetail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.pb.address.AddressInfo} returns this
 */
proto.com.pb.address.AddressInfo.prototype.setAddressDetail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string address_choose = 4;
 * @return {string}
 */
proto.com.pb.address.AddressInfo.prototype.getAddressChoose = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.pb.address.AddressInfo} returns this
 */
proto.com.pb.address.AddressInfo.prototype.setAddressChoose = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional float address_longigute = 5;
 * @return {number}
 */
proto.com.pb.address.AddressInfo.prototype.getAddressLongigute = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.pb.address.AddressInfo} returns this
 */
proto.com.pb.address.AddressInfo.prototype.setAddressLongigute = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional float address_latitute = 6;
 * @return {number}
 */
proto.com.pb.address.AddressInfo.prototype.getAddressLatitute = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.pb.address.AddressInfo} returns this
 */
proto.com.pb.address.AddressInfo.prototype.setAddressLatitute = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional int32 address_province_code = 7;
 * @return {number}
 */
proto.com.pb.address.AddressInfo.prototype.getAddressProvinceCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.pb.address.AddressInfo} returns this
 */
proto.com.pb.address.AddressInfo.prototype.setAddressProvinceCode = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 address_city_code = 8;
 * @return {number}
 */
proto.com.pb.address.AddressInfo.prototype.getAddressCityCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.pb.address.AddressInfo} returns this
 */
proto.com.pb.address.AddressInfo.prototype.setAddressCityCode = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional TRANSPORTATION_MODE transportation_mode = 9;
 * @return {!proto.com.pb.address.TRANSPORTATION_MODE}
 */
proto.com.pb.address.AddressInfo.prototype.getTransportationMode = function() {
  return /** @type {!proto.com.pb.address.TRANSPORTATION_MODE} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.com.pb.address.TRANSPORTATION_MODE} value
 * @return {!proto.com.pb.address.AddressInfo} returns this
 */
proto.com.pb.address.AddressInfo.prototype.setTransportationMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * repeated string transportation_description = 10;
 * @return {!Array<string>}
 */
proto.com.pb.address.AddressInfo.prototype.getTransportationDescriptionList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.com.pb.address.AddressInfo} returns this
 */
proto.com.pb.address.AddressInfo.prototype.setTransportationDescriptionList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.com.pb.address.AddressInfo} returns this
 */
proto.com.pb.address.AddressInfo.prototype.addTransportationDescription = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.pb.address.AddressInfo} returns this
 */
proto.com.pb.address.AddressInfo.prototype.clearTransportationDescriptionList = function() {
  return this.setTransportationDescriptionList([]);
};


/**
 * optional string name = 11;
 * @return {string}
 */
proto.com.pb.address.AddressInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.pb.address.AddressInfo} returns this
 */
proto.com.pb.address.AddressInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string mobile = 12;
 * @return {string}
 */
proto.com.pb.address.AddressInfo.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.pb.address.AddressInfo} returns this
 */
proto.com.pb.address.AddressInfo.prototype.setMobile = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int32 shop_id = 13;
 * @return {number}
 */
proto.com.pb.address.AddressInfo.prototype.getShopId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.pb.address.AddressInfo} returns this
 */
proto.com.pb.address.AddressInfo.prototype.setShopId = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional ADDRESS_TYPE address_type = 14;
 * @return {!proto.com.pb.address.ADDRESS_TYPE}
 */
proto.com.pb.address.AddressInfo.prototype.getAddressType = function() {
  return /** @type {!proto.com.pb.address.ADDRESS_TYPE} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.com.pb.address.ADDRESS_TYPE} value
 * @return {!proto.com.pb.address.AddressInfo} returns this
 */
proto.com.pb.address.AddressInfo.prototype.setAddressType = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.pb.address.AddressTransportationInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.pb.address.AddressTransportationInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.pb.address.AddressTransportationInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.pb.address.AddressTransportationInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    longitute: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    lantitute: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    shopId: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.pb.address.AddressTransportationInfoRequest}
 */
proto.com.pb.address.AddressTransportationInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.pb.address.AddressTransportationInfoRequest;
  return proto.com.pb.address.AddressTransportationInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.pb.address.AddressTransportationInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.pb.address.AddressTransportationInfoRequest}
 */
proto.com.pb.address.AddressTransportationInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitute(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLantitute(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setShopId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.pb.address.AddressTransportationInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.pb.address.AddressTransportationInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.pb.address.AddressTransportationInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.pb.address.AddressTransportationInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLongitute();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getLantitute();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getShopId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional double longitute = 1;
 * @return {number}
 */
proto.com.pb.address.AddressTransportationInfoRequest.prototype.getLongitute = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.pb.address.AddressTransportationInfoRequest} returns this
 */
proto.com.pb.address.AddressTransportationInfoRequest.prototype.setLongitute = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double lantitute = 2;
 * @return {number}
 */
proto.com.pb.address.AddressTransportationInfoRequest.prototype.getLantitute = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.pb.address.AddressTransportationInfoRequest} returns this
 */
proto.com.pb.address.AddressTransportationInfoRequest.prototype.setLantitute = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 shop_id = 3;
 * @return {number}
 */
proto.com.pb.address.AddressTransportationInfoRequest.prototype.getShopId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.pb.address.AddressTransportationInfoRequest} returns this
 */
proto.com.pb.address.AddressTransportationInfoRequest.prototype.setShopId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.pb.address.AddressTransportationInfo.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.pb.address.AddressTransportationInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.com.pb.address.AddressTransportationInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.pb.address.AddressTransportationInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.pb.address.AddressTransportationInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    transportationMode: jspb.Message.getFieldWithDefault(msg, 1, 0),
    transportationDescriptionList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.pb.address.AddressTransportationInfo}
 */
proto.com.pb.address.AddressTransportationInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.pb.address.AddressTransportationInfo;
  return proto.com.pb.address.AddressTransportationInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.pb.address.AddressTransportationInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.pb.address.AddressTransportationInfo}
 */
proto.com.pb.address.AddressTransportationInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.pb.address.TRANSPORTATION_MODE} */ (reader.readEnum());
      msg.setTransportationMode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addTransportationDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.pb.address.AddressTransportationInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.pb.address.AddressTransportationInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.pb.address.AddressTransportationInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.pb.address.AddressTransportationInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransportationMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTransportationDescriptionList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional TRANSPORTATION_MODE transportation_mode = 1;
 * @return {!proto.com.pb.address.TRANSPORTATION_MODE}
 */
proto.com.pb.address.AddressTransportationInfo.prototype.getTransportationMode = function() {
  return /** @type {!proto.com.pb.address.TRANSPORTATION_MODE} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.pb.address.TRANSPORTATION_MODE} value
 * @return {!proto.com.pb.address.AddressTransportationInfo} returns this
 */
proto.com.pb.address.AddressTransportationInfo.prototype.setTransportationMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated string transportation_description = 2;
 * @return {!Array<string>}
 */
proto.com.pb.address.AddressTransportationInfo.prototype.getTransportationDescriptionList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.com.pb.address.AddressTransportationInfo} returns this
 */
proto.com.pb.address.AddressTransportationInfo.prototype.setTransportationDescriptionList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.com.pb.address.AddressTransportationInfo} returns this
 */
proto.com.pb.address.AddressTransportationInfo.prototype.addTransportationDescription = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.pb.address.AddressTransportationInfo} returns this
 */
proto.com.pb.address.AddressTransportationInfo.prototype.clearTransportationDescriptionList = function() {
  return this.setTransportationDescriptionList([]);
};


/**
 * @enum {number}
 */
proto.com.pb.address.TRANSPORTATION_MODE = {
  TRANSPORTATION_MODE_SUSPEND: 0,
  TRANSPORTATION_MODE_2_HOURS_ARRIVE: 1,
  TRANSPORTATION_MODE_INSIDE_FENCING: 2,
  TRANSPORTATION_MODE_OUTSIDE_FENCING: 3,
  TRANSPORTATION_MODE_TAKEOUT: 4,
  TRANSPORTATION_SELF_DISTRIBUTION: 5
};

/**
 * @enum {number}
 */
proto.com.pb.address.ADDRESS_TYPE = {
  ADDRESS_TYPE_NORMAL: 0,
  ADDRESS_TYPE_DEFAULT: 1
};

goog.object.extend(exports, proto.com.pb.address);
